import React from "react";

import connector from "../../utils/reduxConnect/connector";

import { propMapperArray, dispatchMapperArray } from "../../data/constants";

import Transaction from "../../components/pages/Transaction";

import {
  downloadCurrentReport,
  getAnalyticsInfo,
  getChallanList,
} from "../../services";
import Notifications from "../../utils/notifications";

const pageIdentifier = "Transactions";

function Transactions({
  transactionTable,
  transactionTableFetch,
  transactionParams,
  updateTransParams,
  previousTable,
  transactionTablePreviousFetch,
  transactionTableContinuationToken,
  contToken,
  dailyAnalytics,
  weeklyAnalytics,
  monthlyAnalytics,
  dailyAnalyticsFetch,
  weeklyAnalyticsFetch,
  monthlyAnalyticsFetch,
}) {
  function handleUpdateTransParmas(params) {
    updateTransParams(params);
    updateTableInfo(params);
  }

  function validite(params) {
    if (params.economicCode) return true;

    const validationFlag = params.acsRef || params.bkashTrxId || params.mobile;

    return validationFlag;
  }

  const updateTableInfo = async (params, nav = false) => {
    if (!validite(params)) return;

    const newPrev = [...previousTable, [...transactionTable]];
    const endPoint = params.economicCode
      ? "/portal/filter-challan"
      : "/portal/search-challan";

    Notifications.activity("Data fetching...");
    const { data, error } = await getChallanList(endPoint, {
      ...params,
      ...(() => {
        return params.economicCode ? { limit: 100 } : {};
      })(),
    });
    Notifications.clear();

    if (!error) {
      if (data.result?.length > 0) {
        if (transactionTable.length > 0 && params.continuationToken) {
          transactionTablePreviousFetch(newPrev);
        }

        Notifications.success("Data fetched succesfully!");
        transactionTableFetch(data.result);
        transactionTableContinuationToken([
          ...contToken,
          data.continuationToken,
        ]);
      } else if (nav) {
        Notifications.error("No more data found!");
      } else {
        transactionTableFetch(data.result);
      }

      if (params.continuationToken == null) {
        transactionTablePreviousFetch([]);

        if (params.economicCode == null) {
          transactionTableContinuationToken([]);
        }
      }
    } else {
      Notifications.error(data.message);
    }
  };

  const fetchAnalyticsInfo = async () => {
    const paramsCommon = { currentTimestamp: new Date().valueOf() };
    const paramsDaily = { ...paramsCommon, numberOfDays: 1 };
    const paramsWeekly = { ...paramsCommon, numberOfDays: 7 };
    const paramsMonthly = { ...paramsCommon, numberOfDays: 30 };

    const [daily, weekly, monthly] = await Promise.all([
      getAnalyticsInfo(paramsDaily),
      getAnalyticsInfo(paramsWeekly),
      getAnalyticsInfo(paramsMonthly),
    ]);

    if (!daily.error && !weekly.error && !monthly.error) {
      dailyAnalyticsFetch(daily.data);
      weeklyAnalyticsFetch(weekly.data);
      monthlyAnalyticsFetch(monthly.data);
    } else {
      Notifications.error(daily.data.message);
    }
  };

  const populateData = (last) => {
    if (transactionParams.economicCode == null) {
      Notifications.error("Page navigation is not available for searching.");
      return;
    }

    if (last) {
      updateTableInfo(
        {
          ...transactionParams,
          continuationToken: contToken[contToken.length - 1],
        },
        true
      );
    } else {
      if (previousTable.length > 0) {
        const previous = [...previousTable];
        const contTokeNew = [...contToken];
        contTokeNew.pop();

        transactionTableFetch(previous.pop());
        transactionTablePreviousFetch(previous);
        transactionTableContinuationToken(contTokeNew);
      } else {
        Notifications.error("You are at first page.");
      }
    }
  };

  const downloadCurrent = async () => {
    const params = {
      type: transactionParams.economicCode ? "filter" : "search",
    };

    Notifications.activity("Fetching report data...");
    await downloadCurrentReport(params, transactionParams);
    Notifications.clear();
  };

  React.useEffect(() => {
    updateTableInfo(transactionParams);
    fetchAnalyticsInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Transaction
      transactionTable={transactionTable}
      params={transactionParams}
      updateParams={handleUpdateTransParmas}
      populateData={populateData}
      pageNo={previousTable.length}
      analyticsInfo={[dailyAnalytics, weeklyAnalytics, monthlyAnalytics]}
      downloadCurrent={downloadCurrent}
    />
  );
}

export default connector(
  propMapperArray[pageIdentifier],
  dispatchMapperArray[pageIdentifier]
)(Transactions);
